import formatDataFilter from '@/views/filters/format-data-filter'

export default {
	install(Vue) {
		Vue.filter('formatDataFilter', formatDataFilter)
	}
}
